import { ContactConfig } from '../../contact.types';

export default {
  links: [
    {
      label: 'Check out QSEP FAQ for more info on QSEP',
      link: 'https://qsep.cms.gov/Help/frequently-asked-questions.aspx',
    },
  ],
  contactDetails: {
    hours: '8:00 AM - 7:00 PM ET',
    days: 'Monday - Friday',
    email: 'helpdesk@qsep.org',
    phone1: '1-855-791-8900',
  },
  footerText: `
    QSEP support is not available via CCSQ Support Central.
    Please select <a href="https://cmsqualitysupport.servicenowservices.com/qsep" target="_blank">
    CMS QSEP Help Center</a> for online support
  `,
} as ContactConfig;
